<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.0002 5.99963C11.0002 8.75963 8.76021 10.9996 6.00021 10.9996C3.24021 10.9996 1.00021 8.75963 1.00021 5.99963C1.00021 3.23963 3.24021 0.999634 6.00021 0.999634C8.76021 0.999634 11.0002 3.23963 11.0002 5.99963Z"
      :stroke="color"
      stroke-width="0.75"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M7.85483 7.58964L6.30483 6.66464C6.03483 6.50464 5.81483 6.11964 5.81483 5.80464V3.75464"
      :stroke="color"
      stroke-width="0.75"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script>
export default {
  name: 'IconClock',
  props: {
    size: {
      type: [Number, String],
      default: 12
    },
    color: {
      type: String,
      default: 'currentColor'
    }
  }
};
</script>
